import React, { Component, Fragment, createRef } from "react";
import AppContext from "../../contexts/AppContext";
import StepsHeader from "./include/StepsHeader";
import CheckoutSteps from "./include/CheckoutSteps";
import { checkToken, updateUserWithToken } from "../../services/user";

export class PersonalDetail extends Component {	

    fileUpload = React.createRef();
    form = React.createRef();
    state = {
        validToken: true,
        item: {
            first_name: '',
            last_name: '',
            category_id: '',
			location: '',
            byLine: '',
            image: '',
            personalWebsite: '',
            linkedin: '',
            facebook: '',
            twitter: '',
            instagram: '',            
        },
        errors: {},
        loading: false,
        roles: [],
        file: '/images/default.jpg', 
        selectedFile: null,
    };

    componentDidMount() {        
        
        checkToken({ token: this.props.match.params["token"], type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    this.setState({
                        item: res.data,    
                    });                    
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
    };

    
    openFile = e => {
        e.preventDefault();
        this.fileUpload.current.click();
    }
    
    handleChange = e => {
        let errors = this.state.errors;
        if (e.target.files[0] && !this.isImage(e.target.files[0].name)) {
            errors['image'] = "Please select a valid image file.";
            this.setState({errors: errors, file: '/images/default.jpg', selectedFile : null});
        }else
        {
            errors['image'] = null;
            this.setState({
                errors: errors,
                file: URL.createObjectURL(e.target.files[0]),
                selectedFile: e.target.files[0]
              })
        }
        
    }
    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };

    getExtension(filename) {
        let parts = filename.split('.');
        return parts[parts.length - 1];
    }

    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
          case 'jpg':
          case 'gif':
          case 'bmp':
          case 'png':
            //etc
            return true;
        }
        return false;
    }

    handleValidation = () => {
        
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        let profilePicture = this.state.selectedFile;  

        if(!fields.first_name){
            formIsValid = false;
            errors.first_name = "The first name field is required.";
        }

        if(!fields.last_name){
            formIsValid = false;
            errors.last_name = "The last name field is required.";
        }

        if (profilePicture == ''){
            formIsValid = false;
            errors.image = "The profile picture field is required.";
        }

        if (profilePicture && profilePicture.size / 1024 / 1024 > 2) {
            errors.image = "File size exceeds 2 MB";
        } 
        
        if (profilePicture && !this.isImage(profilePicture.name)) {
            errors.image = "Please select a valid image file.";
        }
        
        
        this.setState({errors: errors});
        return formIsValid;
    }  

    handleSubmit = e => {
        e.preventDefault();
        const formData = new FormData(this.form.current);       
        if(this.handleValidation()){ 
            this.setState({loading: true});             
            formData.append('fname',this.state.item.first_name);
            formData.append('lname',this.state.item.last_name);      
            if(this.state.selectedFile)
            {
                formData.append(
                    'profile_image',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }

            if (this.state.item.byLine != undefined){
                formData.append('byLine', this.state.item.byLine);
            }
            
            if (this.state.item.location != undefined) {
                formData.append('location',this.state.item.location); 
            }
            
            if (this.state.item.personalWebsite != undefined) {
                formData.append('personalWebsite',this.state.item.personalWebsite);
            }

            if (this.state.item.linkedin != undefined) {
                formData.append('linkedin', this.state.item.linkedin);
            }

            if (this.state.item.facebook != undefined) {
                formData.append('facebook',this.state.item.facebook);
            }

            if (this.state.item.twitter != undefined) {
                formData.append('twitter',this.state.item.twitter);
            }

            if (this.state.item.instagram != undefined) {
                formData.append('instagram',this.state.item.instagram);
            }

            formData.append('step','personal');
            formData.append('token_type','pwonbs1');
            updateUserWithToken(formData, this.props.match.params["token"])
            .then(res => {
                this.setState({loading: false}); 
				//this.context.state.showCodeMessage(res.message,'success'); 
                if (res.meta.token) {
					this.props.history.push('/process/select-interests/' + res.meta.token);                    
                }                
            })
            .catch(errors => {
                this.setState({loading: false}); 
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });

            //console.log(formData.values(),this.state.item);
        }        
    }; 

    back = () => {
		this.props.history.push('/process/account-details/' + this.props.match.params["token"]); 
	}
	
	render() {
		
		
		return (
            <Fragment>
                <div className="account-wrapper">
				    <StepsHeader></StepsHeader>
                    <section className="checkout pb-5">
				        <div className="container position-relative">				    	    
				    	    <CheckoutSteps onboardStep="[1,2]" show="2"></CheckoutSteps>	
				    	    <div className="create-profile mx-auto mb-3">    
								<h3 className="mb-2 text-md-center">Complete Your Profile:</h3>
                                <p className="mb-4 text-md-center text-dark">Fill in your personal details to help employers know more about you.</p>								
				    			<form method="POST" ref={this.form}>
                                    <div className="row justify-content-center no-gutters"> 
                                        <div className="col-lg-6">									
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group mb-4">
                                                        <label htmlFor="first_name" className="sr-only">First Name*</label>
                                                        <input type="text"  className="form-control" value={ this.state.item.first_name } onChange={ this.onChange} name="first_name" id="first_name" ref="first_name" placeholder="First Name*" autoComplete="off" />
                                                        {this.state.errors.first_name ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.first_name}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group mb-4">
                                                        <label htmlFor="last_name" className="sr-only">Last Name*</label>
                                                        <input type="text"  className="form-control" value={ this.state.item.last_name } onChange={ this.onChange} name="last_name" id="last_name" ref="last_name" placeholder="Last Name*" autoComplete="off" />
                                                        {this.state.errors.last_name ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.last_name}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group mb-4">
                                                        <label htmlFor="fname" className="sr-only">Location</label>
                                                        <input type="text"  className="form-control" onChange={ this.onChange} name="location" id="location" ref="location" placeholder="Location" autoComplete="off" />
                                                        {this.state.errors.location ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.location}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
												    {/*<div className="form-group mb-4">
                                                        <label htmlFor="profile_picture" className="sr-only">Profile Picture*</label>
                                                        <input type="file"  className="form-control" name="profile_picture" id="profile_picture" ref="fname" placeholder="Profile Picture*" autoComplete="off" />
                                                    </div>*/}
													<div className="row no-gutters mb-4">
													    <div className="col-2">
														    <img className="profile-pic" src={this.state.file} alt="profile-pic"/>
														</div>
													    <div className="col-10 pl-4">
                                                            <input type="file" ref={this.fileUpload} name="image" onChange={this.handleChange} hidden />
														    <button className="btn btn-primary border-0" onClick={this.openFile}>Upload profile picture</button>
														</div> 
                                                        {this.state.errors.image ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.image}
                                                            </div>
                                                        ) : null} 
													</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group mb-4">
                                                        <label htmlFor="byline" className="sr-only">Describe you and your writing experience in 2 to 4 sentences</label>
                                                        <textarea className="form-control" name="byLine" onChange={ this.onChange} id="byline" ref="byline" placeholder="Describe you and your writing experience in 2 to 4 sentences..." autoComplete="off" ></textarea>
                                                        
                                                    </div>
                                                    {this.state.errors.byLine ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.byLine}
                                                            </div>
                                                        ) : null} 
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group mb-4 position-relative url">
                                                        <label htmlFor="url" className="sr-only">Personal website</label>
                                                        <input type="url"  className="form-control fw" onChange={ this.onChange} name="personalWebsite" id="url" ref="url" placeholder="Personal website" autoComplete="off" />
                                                    </div>
                                                    {this.state.errors.personalWebsite ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.personalWebsite}
                                                            </div>
                                                        ) : null}
                                                </div>                                                
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group mb-4 position-relative fb">
                                                        <label htmlFor="fb_url" className="sr-only">Facebook</label>
                                                        <div className="input-group">
														    <div className="input-group-prepend">
                                                              <div className="input-group-text">Facebook.com/</div>
                                                            </div>
														    <input type="text"  className="form-control fw" onChange={ this.onChange} name="facebook" id="fb_url" ref="fb_url" placeholder="John-Smith" autoComplete="off" />
														</div>
                                                    </div>
                                                    {this.state.errors.facebook ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.facebook}
                                                            </div>
                                                        ) : null}
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group mb-4 position-relative twt">
                                                        <label htmlFor="twitter_url" className="sr-only">Twitter</label>
														<div className="input-group">
														    <div className="input-group-prepend">
                                                              <div className="input-group-text">Twitter.com/</div>
                                                            </div>
                                                            <input type="url"  className="form-control fw" onChange={ this.onChange} name="twitter" id="twitter_url" ref="twitter_url" placeholder="John-Smith" autoComplete="off" />                                                        
														</div>
                                                    </div>
                                                    {this.state.errors.twitter ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.twitter}
                                                            </div>
                                                        ) : null}
                                                </div>                                                
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group mb-4 position-relative linke">
                                                        <label htmlFor="linkedin_url" className="sr-only">Linkedin</label>
														<div className="input-group">
														    <div className="input-group-prepend">
                                                              <div className="input-group-text">Linkedin.com/in/</div>
                                                            </div>
                                                            <input type="text"  className="form-control fw" onChange={ this.onChange} name="linkedin" id="linkedin_url" ref="linkedin_url" placeholder="John-Smith" autoComplete="off" />
														</div>	
                                                    </div>
                                                    {this.state.errors.linkedin ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.linkedin}
                                                            </div>
                                                        ) : null}
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group mb-4 position-relative insta">
                                                        <label htmlFor="instagram_url" className="sr-only">Instagram</label>
                                                        <div className="input-group">
														    <div className="input-group-prepend">
                                                              <div className="input-group-text">Instagram.com/</div>
                                                            </div>
														    <input type="url"  className="form-control fw" onChange={ this.onChange} name="instagram" id="instagram_url" ref="instagram_url" placeholder="John-Smith" autoComplete="off" />                                                        
														</div>
                                                    </div>
                                                    {this.state.errors.instagram ? (
                                                            <div className="invalid-feedback">
                                                                {this.state.errors.instagram}
                                                            </div>
                                                        ) : null}
                                                </div>                                                
                                            </div>
										</div>	
                                    </div>
                                </form>
							</div>
                            <hr className="my-5"/>
							<div className="d-flex align-items-center justify-content-between flex-md-row flex-column">
                                <button type="button" onClick={() => this.back()} className="btn back btn-primary border-0">Back</button>								
							    <button type="button" onClick={this.handleSubmit} disabled={this.state.loading} className="btn continue btn-primary border-0 mb-md-0 mb-3"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue`}</button>								
							</div>
						</div>		
				    </section>
				</div>	
            </Fragment>
        );
    }
}

PersonalDetail.contextType = AppContext;
export default PersonalDetail;



// WEBPACK FOOTER //
// ./src/components/general/PersonalDetail.js